var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"premium-feature__container"},[_c('v-icon',{attrs:{"small":"","id":"premium-feature-icon"}},[_vm._v("mdi-diamond-stone")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }